// Poodle Talk family-account auth helper (SEPARATE from Lumi admin auth).
//
// Storage: a single string in localStorage under `poodletalk_session_token`.
// The token is ALSO set as an HttpOnly cookie on the API domain, but Safari
// ITP frequently drops third-party cookies, so we keep the token in localStorage
// and add it to outgoing Authorization headers as a belt-and-braces fallback.

import axios from "axios";
import { API } from "../constants";

const TOKEN_KEY = "poodletalk_session_token";

export function getPtToken() {
  try {
    return localStorage.getItem(TOKEN_KEY) || "";
  } catch {
    return "";
  }
}

export function setPtToken(token) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* private mode — ignore */
  }
}

export function clearPtToken() {
  setPtToken("");
}

/** Returns headers object with Authorization if signed in, else {}. */
export function ptAuthHeaders() {
  const t = getPtToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

/** Fetch the current signed-in Poodle Talk user, or null if guest. */
export async function fetchPtUser() {
  const t = getPtToken();
  if (!t) return null;
  try {
    const r = await axios.get(`${API}/poodletalk/auth/me`, {
      headers: { Authorization: `Bearer ${t}` },
    });
    return r.data;
  } catch (e) {
    if (e?.response?.status === 401) clearPtToken();
    return null;
  }
}

export async function ptLogout() {
  const t = getPtToken();
  try {
    if (t) {
      await axios.post(`${API}/poodletalk/auth/logout`, null, {
        headers: { Authorization: `Bearer ${t}` },
      });
    }
  } catch {
    /* ignore — local clear is what matters */
  }
  clearPtToken();
}

/** Kicks off the Emergent Google Auth flow. */
export function startPtLogin() {
  // Always return the user to the SPA root so the AuthCallback can run.
  const redirectUrl = window.location.origin + "/";
  // DO NOT HARDCODE OR ADD FALLBACKS — Emergent auth requires the literal URL.
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}
